// Shared outlines: the visible rock, collision fixtures and build clearance agree.
export function rockOutline(x,y,width,depth){
  return [[-.5,0],[.5,0],[.46,-.36],[.19,-.48],[.05,-1],[-.19,-.73],[-.43,-.38]].map(([u,v])=>({x:x+u*width,y:y+v*depth}));
}
export function rockTriangles(rock){
  const p=rockOutline(rock.x,rock.y,rock.width,rock.depth),tip={x:rock.x,y:rock.y};
  return p.slice(1).map((a,i)=>[tip,a,p[(i+2)%p.length]]);
}
export function rectangle(p,a,w,h){
  const c=Math.cos(a),s=Math.sin(a);
  return [[-w/2,-h/2],[w/2,-h/2],[w/2,h/2],[-w/2,h/2]].map(([x,y])=>({x:p.x+x*c-y*s,y:p.y+x*s+y*c}));
}
export function overlaps(a,b,skin=.012){
  for(const polygon of [a,b])for(let i=0;i<polygon.length;i++){
    const p=polygon[i],q=polygon[(i+1)%polygon.length],dx=q.y-p.y,dy=p.x-q.x,length=Math.hypot(dx,dy);
    if(length<1e-8)continue;
    const ax=dx/length,ay=dy/length,pa=a.map(v=>v.x*ax+v.y*ay),pb=b.map(v=>v.x*ax+v.y*ay);
    if(Math.max(...pa)<=Math.min(...pb)+skin||Math.max(...pb)<=Math.min(...pa)+skin)return false;
  }
  return true;
}
export function intersectsTerrain(poly,solids){return solids.some(s=>s.triangles.some(t=>overlaps(poly,t)));}
